import React from "react";
import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const langs = [
    { code: "pt", label: "PT" },
    { code: "en", label: "EN" },
    { code: "es", label: "ES" },
  ];
  return (
    <div className="inline-flex rounded-full bg-white/70 backdrop-blur-md border border-slate-200 p-1 shadow-sm" data-testid="lang-switcher">
      {langs.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`px-3 py-1 text-xs font-bold rounded-full transition-all ${
            lang === l.code
              ? "bg-sky-500 text-white shadow"
              : "text-slate-600 hover:text-slate-900"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
